import { Button } from "@mui/material";
import SyncIcon from '@mui/icons-material/Sync';

export default function ButtonSyncManual({teste, ...props}){
    return(
        // <Button sx={{textTransform: "initial", variant="outlined",fontSize:"0.7rem", textDecoration: "underline"}} {...props} color="blueSys">Gerenciar permissões</Button>
        <Button variant="outlined" startIcon={<SyncIcon />}   color="blueSys" sx={{textTransform: "initial"}} {...props}>Sincronização manual</Button>
    )
}